'use strict';

import Config from '../util/Config';
import Util from '../util/Util';
import HtmlClass from '../util/HtmlClass';
import SmoothScroll from '../util/SmoothScroll';
import Header from './Header';
import InertialScroll from './InertialScroll';
import Footer from './Footer';
import Module from './Module';
// import Cursor from './Cursor';
import Top from './Top';
import Information from './Information';
// import Contact from './Contact';
import GetEntries from './GetEntries';
// import ScrollEffect from './ScrollEffect';

class App {
	constructor() {
		this.$html = $('html');
		this.html = document.querySelector('html');
		this.Config = Config;
		this.Util = new Util();
		this.Header = new Header();
		this.InertialScroll = new InertialScroll();
		// this.Cursor = new Cursor();
		this.Footer = new Footer();
	}

	render() {
		HtmlClass.render();
		SmoothScroll.render('.ss');
		SmoothScroll.render('.wp-block-anchorlink__list a');
		this.Header.render();
		this.Footer.render();
		this.InertialScroll.render();
		// this.Cursor.render();
		new Module();

		if (document.body.classList.contains('top')) {
			new Top();
		}
		if (document.body.classList.contains('information')) {
			new Information();
		}

		// 非同期の一覧（お知らせ一覧など）。ページ側で .js_entries を付けたら効く。
		// 必要な子要素は GetEntries.js のコメント／archive-news.php を参照
		document.querySelectorAll('.js_entries').forEach((el) => {
			new GetEntries(el);
		});
		// if (document.body.classList.contains('contact')) {
		// 	new Contact();
		// }
	}
}

export default App;
